import React from 'react'
import WorkCard from './WorkCard'
import './works.css'
import Frame1 from '../assets/Frame1.png'
import Frame2 from '../assets/Frame2.png'

const works = [
    {
        title: 'Fatest way to organize',
        text: 'Most calenders are designed for teams. Slate is designed for freelancers who want a simple way to plan their schedule.',
        img: Frame1
    },
    {
        title: 'Lightning fast prototyping',
        text: 'Most calenders are designed for teams. Slate is designed for freelancers who want a simple way to plan their schedule.',
        img:Frame2  
    }
]

function Works() {
  return (
      <div id='Experience' className='works-container' style={{ width: "100%" }}>
          {
              works.map((work, index) => {
                    return <WorkCard position={index+1} title={work.title} text={work.text} img={work.img} />
                })
          }
          {/* <WorkCard/>   
          <WorkCard/>    */}
      </div>
  )
}

export default Works